import { Outlet } from 'react-router-dom';
import { TrinetraLoop3 } from '@/components/icons/trinetra-icons';
import { Link } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <header className="p-4">
        <Link to="/" className="inline-flex items-center gap-2">
          <TrinetraLoop3 className="h-7 w-7 text-primary-strong" />
          <span className="font-display text-lg font-semibold tracking-wide text-foreground">Trinetra</span>
        </Link>
      </header>
      <main className="flex-1 flex items-center justify-center px-4 pb-16">
        <Outlet />
      </main>
    </div>
  );
}
